module.exports = __webpack_public_path__ + "img/working.4a6588c1.svg";